module.exports = __webpack_public_path__ + "static/media/massage-we-facilitate.d3c0600f.jpg";